import { BgPosition } from '@components/card';
import { createElement } from 'react';

import { Slide } from './types';

import ArrowCounterClockwiseClockStroke from '@/assets/icons/iconArrowCounterClockwiseClockStroke.svg';
import BubbleEllipsisStroke from '@/assets/icons/iconBubbleEllipsisStroke.svg';
import BulletListStroke from '@/assets/icons/iconBulletListStroke.svg';
import ClockStroke from '@/assets/icons/iconClockStroke.svg';
import ClockwiseStroke from '@/assets/icons/iconClockwiseStroke.svg';
import CloudArrowUpStroke from '@/assets/icons/iconCloudArrowUpStroke.svg';
import EnvelopeStroke from '@/assets/icons/iconEnvelopeStroke.svg';
import ImageStroke from '@/assets/icons/iconImageStroke.svg';
import LocationWavesNorthFill from '@/assets/icons/iconLocationWavesNorthFill.svg';
import RouteMiniMapStroke from '@/assets/icons/iconRouteMiniMapStroke.svg';
import { ArrowGoForward10Stroke48 } from '@/shared/icons/48/ArrowGoForward10Stroke48';
import { BanknoteCoinsStroke48 } from '@/shared/icons/48/BanknoteCoinsStroke48';
import { ImageSlashStroke48 } from '@/shared/icons/48/ImageSlashStroke48';
import { MapStroke48 } from '@/shared/icons/48/MapStroke48';
import { PencilStroke48 } from '@/shared/icons/48/PencilStroke48';
import { ScalesStroke48 } from '@/shared/icons/48/ScalesStroke48';

export const SERVICE_SLIDES: Array<{
  order: number;
  titleKey: string;
  descriptionKey: string;
  icon: React.ReactNode;
}> = [
  {
    order: 1,
    titleKey: 'staticApiServiceSectionContactsSlideTitle',
    descriptionKey: 'staticApiServiceSectionContactsSlide',
    icon: createElement(BubbleEllipsisStroke),
  },
  {
    order: 3,
    titleKey: 'staticApiServiceSectionMaterialSlideTitle',
    descriptionKey: 'staticApiServiceSectionMaterialSlide',
    icon: createElement(ImageStroke),
  },
  {
    order: 2,
    titleKey: 'staticApiServiceSectionMailingSlideTitle',
    descriptionKey: 'staticApiServiceSectionMailingSlide',
    icon: createElement(EnvelopeStroke),
  },
  {
    order: 5,
    titleKey: 'staticApiServiceSectionIntegrationSlideTitle',
    descriptionKey: 'staticApiServiceSectionIntegrationSlide',
    icon: createElement(RouteMiniMapStroke),
  },
  {
    order: 4,
    titleKey: 'staticApiServiceSectionEfficiencySlideTitle',
    descriptionKey: 'staticApiServiceSectionEfficiencySlide',
    icon: createElement(ClockStroke),
  },
  {
    order: 6,
    titleKey: 'staticApiServiceSectionPreviewSlideTitle',
    descriptionKey: 'staticApiServiceSectionPreviewSlide',
    icon: createElement(BulletListStroke),
  },
  {
    order: 7,
    titleKey: 'staticApiServiceSectionHistorySlideTitle',
    descriptionKey: 'staticApiServiceSectionHistorySlide',
    icon: createElement(LocationWavesNorthFill),
  },
  {
    order: 8,
    titleKey: 'staticApiServiceSectionPlaceholderSlideTitle',
    descriptionKey: 'staticApiServiceSectionPlaceholderSlide',
    icon: createElement(ClockwiseStroke),
  },
];

export const HOW_IT_WORKS_CARDS: Array<{
  id: string;
  stepNumber: string;
  descriptionKey: string;
  pcPlacement: BgPosition;
  mobilePlacement: BgPosition;
}> = [
  {
    id: 'step-1',
    stepNumber: '01',
    descriptionKey: 'staticApiHowItWorksSectionIntegrationCard',
    pcPlacement: 'bottom-left',
    mobilePlacement: 'top-left',
  },
  {
    id: 'step-2',
    stepNumber: '02',
    descriptionKey: 'staticApiHowItWorksSectionImageGenerationCard',
    pcPlacement: 'top-right',
    mobilePlacement: 'top-right',
  },
  {
    id: 'step-3',
    stepNumber: '03',
    descriptionKey: 'staticApiHowItWorksSectionImageDownloadCard',
    pcPlacement: 'bottom-right',
    mobilePlacement: 'bottom-left',
  },
];

type ServiceSlide = Slide;

export const SERVICE_ADVANTAGES_SLIDES: ServiceSlide[] = [
  {
    id: '1',
    titleKey: 'staticApiServiceAdvantagesSectionMapSlideTitle',
    descriptionKey: 'staticApiServiceAdvantagesSectionMapSlideDescription',
    icon: createElement(MapStroke48),
  },
  {
    id: '2',
    titleKey: 'staticApiServiceAdvantagesSectionPerformanceSlideTitle',
    descriptionKey:
      'staticApiServiceAdvantagesSectionPerformanceSlideDescription',
    icon: createElement(ArrowGoForward10Stroke48),
  },
  {
    id: '3',
    titleKey: 'advantageTransparentPaymentTitle',
    descriptionKey: 'staticApiServiceAdvantagesSectionPaymentSlideDescription',
    icon: createElement(BanknoteCoinsStroke48),
  },
  {
    id: '4',
    titleKey: 'staticApiServiceAdvantagesSectionNoAdSlideTitle',
    descriptionKey: 'staticApiServiceAdvantagesSectionNoAdSlideDescription',
    icon: createElement(ImageSlashStroke48),
  },
  {
    id: '5',
    titleKey: 'advantageEasyIntegrationTitle',
    descriptionKey:
      'staticApiServiceAdvantagesSectionIntegrationSlideDescription',
    icon: createElement(CloudArrowUpStroke),
  },
  {
    id: '6',
    titleKey: 'staticApiServiceAdvantagesSectionSimpleSlideTitle',
    descriptionKey: 'staticApiServiceAdvantagesSectionSimpleSlideDescription',
    icon: createElement(PencilStroke48),
  },
  {
    id: '7',
    titleKey: 'staticApiServiceAdvantagesSectionSimpleStableTitle',
    descriptionKey: 'staticApiServiceAdvantagesSectionSimpleStableDescription',
    icon: createElement(ArrowCounterClockwiseClockStroke),
  },
  {
    id: '8',
    titleKey: 'staticApiServiceAdvantagesSectionSimpleFlexibleTitle',
    descriptionKey:
      'staticApiServiceAdvantagesSectionSimpleFlexibleDescription',
    icon: createElement(ScalesStroke48),
  },
  {
    id: '9',
    titleKey: 'staticApiServiceAdvantagesSectionSimpleSummaryTitle',
    variant: 'summary',
    imageSrc: {
      sm: '/images/api_static/dev_static_api_use_case_bg_sm.png',
      lg: '/images/api_static/dev_static_api_use_case_bg_lg.png',
    },
  },
];

export const FAQ_ITEMS = [
  {
    id: 'faqAccessTitle',
    title: 'howToGetAccessQuestion',
    content: 'howToGetAccessAnswer',
  },
  {
    id: 'staticApiFaqSectionItemCashTitle',
    title: 'staticApiFaqSectionItemCashTitle',
    content: 'staticApiFaqSectionItemCashContent',
  },
  {
    id: 'staticApiFaqSectionItemRestrictionTitle',
    title: 'staticApiFaqSectionItemRestrictionTitle',
    content: 'staticApiFaqSectionItemRestrictionContent',
  },
  {
    id: 'staticApiFaqSectionItemQueryTitle',
    title: 'staticApiFaqSectionItemQueryTitle',
    content: 'staticApiFaqSectionItemQueryContent',
  },
  {
    id: 'staticApiFaqSectionItemImageFormatTitle',
    title: 'staticApiFaqSectionItemImageFormatTitle',
    content: 'staticApiFaqSectionItemImageFormatContent',
  },
  {
    id: 'faqMapElementsQuestion',
    title: 'faqMapElementsQuestion',
    content: 'staticApiFaqSectionItemMapElementsContent',
  },
  {
    id: 'faqMapRegionsQuestion',
    title: 'faqMapRegionsQuestion',
    content: 'staticApiFaqSectionItemMapRegionsContent',
  },
];
